import React from 'react';
import { graphql } from 'gatsby';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import LiveEditor from "../components/ComponentLibrary/Code/live-editor";
import PropsTable from "../components/ComponentLibrary/props-table";
import SlotsTable from "../components/ComponentLibrary/slots-table";
import EventsTable from "../components/ComponentLibrary/events-table";
import SEO from "@rocketseat/gatsby-theme-docs/src/components/SEO";
import Sidebar from "@rocketseat/gatsby-theme-docs/src/components/Sidebar";
import { Container, Main, Children } from "@rocketseat/gatsby-theme-docs/src/components/Layout/styles";
import ComponentLibraryContents from "../components/ComponentLibraryTOC/index";
import { convertReadmeMarkdownLink } from "../utils/code-utils";
import { addIcons } from 'ionicons';
import * as icons from 'ionicons/icons';

class ComponentLibraryPage extends React.Component {
    render() {
        const components = this.props.data.allDistJson.edges[0].node.components;
        let component;

        // Dynamically add all icons to Ionicons
        const allIcons = Object.keys(icons).reduce((acc, iconName) => {
            acc[iconName] = icons[iconName];
            return acc;
        }, {});

        addIcons(allIcons);

        components.forEach((pageComponent) => {
            if (pageComponent.tag === this.props.pageContext.componentName) {
                component = pageComponent;
            }
        })

        let componentDocs = convertReadmeMarkdownLink(component.docs);

        return (
            <>
                <SEO title={'component-library'}></SEO>
                <Container>
                    <Sidebar isMenuOpen={true}></Sidebar>
                    <Main>
                        <Children>
                            <h1>
                                <pre>{`<`}{component.tag}{`>`}</pre>
                            </h1>
                            {/*<div dangerouslySetInnerHTML={{__html: componentDocs}}></div>*/}
                            <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                                {componentDocs}
                            </ReactMarkdown>
                            <h2>Usage</h2>
                            <LiveEditor component={component.usage.example}/>
                            <PropsTable componentProps={component.props}></PropsTable>
                            <SlotsTable componentSlots={component.slots}></SlotsTable>
                            <EventsTable componentEvents={component.events}></EventsTable>
                        </Children>
                        <ComponentLibraryContents></ComponentLibraryContents>
                    </Main>
                </Container>
            </>
        )
    }
}

export const query = graphql`
    query ($componentName: String!) {
      allDistJson(filter: {components: {elemMatch: {tag: {eq: $componentName}}}}) {
        edges {
          node {
            components {
              tag
              docs
              usage { example }
              props {
                default
                docs
                name
                type
                required
              }
              slots {
                docs
                name
              }
              events {
                event
                docs
              }
            }
          }
        }
      }
    }
`;

export default ComponentLibraryPage;
